module.exports = __webpack_public_path__ + "img/roll_s copy.73445ae1.png";